// India-locale date formatters shared across portal, marketplace, and pro-sites.
// Centralized here so the wire format stays consistent — three apps previously
// duplicated these identical `toLocaleDateString("en-IN", ...)` calls.

const LOCALE = "en-IN" as const;

// "14 Dec 2024"
export function formatDate(value: string | Date): string {
	return new Date(value).toLocaleDateString(LOCALE, {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
}

// "14 December 2024"
export function formatDateLong(value: string | Date): string {
	return new Date(value).toLocaleDateString(LOCALE, {
		day: "numeric",
		month: "long",
		year: "numeric",
	});
}

// "14 Dec 2024, 10:30 AM"
export function formatDateTime(value: string | Date): string {
	return new Date(value).toLocaleDateString(LOCALE, {
		day: "numeric",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}

// "14 December 2024, 10:30 AM"
export function formatDateTimeLong(value: string | Date): string {
	return new Date(value).toLocaleString(LOCALE, {
		day: "numeric",
		month: "long",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}

// "December 2024" — used in marketplace location pages.
export function formatMonthYear(value: string | Date = new Date()): string {
	return new Date(value).toLocaleDateString(LOCALE, {
		month: "long",
		year: "numeric",
	});
}

// "14 Dec" — compact chip variant used in WhatsApp / CRM timelines.
export function formatDayMonth(value: string | Date): string {
	return new Date(value).toLocaleDateString(LOCALE, {
		day: "numeric",
		month: "short",
	});
}
